const deleteDialog = {
  state: {
    status: false,
    item: ''
  },
  mutations: {
    setDeleteDialogStatus (state: any, payload: any) {
      state.status = payload
    },
    setDeleteDialogItem (state: any, payload: any) {
      state.item = payload
    }
  }
}

export default deleteDialog
